export default {"src":"/_next/static/media/select-bar-checkmark-inactive.component.6abf1a6f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};